"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonBootstrap = void 0;
const core_1 = require("@nestjs/core");
const swagger_1 = require("./swagger");
const common_1 = require("@nestjs/common");
const logger_1 = require("./logger");
class CommonBootstrap {
    async bootstrap(portNumber, moduleObject, moduleName, gatewayUrl, serviceName) {
        const app = await core_1.NestFactory.create(moduleObject);
        const logger = (0, logger_1.createLogger)();
        app.useLogger(logger);
        // const globalPrefix = 'policy-service';
        // app.setGlobalPrefix(globalPrefix);
        const port = portNumber;
        app.enableCors({
            origin: "*", // Allow all origin
        });
        app.useGlobalPipes(new common_1.ValidationPipe({
            whitelist: true, // Automatically strip out properties that are not in the DTO
            forbidNonWhitelisted: true, // Throw an error if unknown properties are provided
            transform: true, // Automatically transform payloads to match DTO types
        }));
        console.log("ENV.PORT_POLICY_SERVICE", portNumber);
        console.log("process.env.PORT", port);
        // Set up Swagger documentation for the Policy Service
        (0, swagger_1.setupSwagger)(app, `${moduleName}`, serviceName, gatewayUrl);
        await app.listen(port);
    }
}
exports.CommonBootstrap = CommonBootstrap;
